import {BaseContainerModel} from '../../base-container.model';
import { bl_dgmkt_segment_hdr_RowClass } from '../../../dbschema/bl_dgmkt_segment_hdr.model';

export class SegmentHeaderContainerModel extends BaseContainerModel {
    bl_dgmkt_segment_hdr: bl_dgmkt_segment_hdr_RowClass = new bl_dgmkt_segment_hdr_RowClass();
}